import { z } from 'zod';

import { creativeFormatIdSchema } from './creative.js';
import { PRESENTER_ACTIONS } from './studio-models.js';

/**
 * KREATİF DİREKTÖRÜ — tezgâhın yanındaki sohbet (21 Ağu 2026).
 *
 * ═══════════════════════════════════════════════════════════════════════════
 * Ne yapıyor: FORMU DOLDURUYOR. Ne yapmıyor: ÜRETİM BAŞLATMIYOR.
 * ═══════════════════════════════════════════════════════════════════════════
 * Model bir tur sonunda iki şey döndürüyor: söyleyeceği cümle ve formun
 * yamalanmış hâli. Yamayı ARAYÜZ uyguluyor, alanlar kullanıcının GÖZÜ ÖNÜNDE
 * doluyor ve "Üret" düğmesine yine kullanıcı basıyor.
 *
 * Doğrudan üretim başlatan bir araç da yazılabilirdi ve bilerek yazılmadı:
 *
 *   · Üretim KREDİ yakıyor. Bir sohbet cümlesinin yanlış anlaşılması,
 *     kullanıcının parasını harcayan bir eyleme dönüşmemeli.
 *   · Yamayı görmek bir DENETİM. Model yanlış ürünü ya da yanlış sahneyi
 *     seçtiyse kullanıcı bunu formda görüyor; gizli bir araç çağrısında
 *     ancak çıktıya bakarak anlardı.
 *   · Form elle kullanılabilir KALIYOR (ürün kararı). Sohbetin formu
 *     sürmesi ile formun yerine geçmesi farklı şeyler.
 *
 * ═══════════════════════════════════════════════════════════════════════════
 * 🔴 KONUŞMA SUNUCUDA SAKLANMIYOR — istemci taşıyor
 * ═══════════════════════════════════════════════════════════════════════════
 * `AgentConversation` / `AgentMessage` tabloları var ve KULLANILMADI. Sebep
 * kapsam: o iki tablo ajanın kimliğine, KPI'larına, öneri akışına ve araç
 * kayıt defterine bağlı; kreatif direktörünün hiçbirine ihtiyacı yok ve
 * oraya bağlanmak, bir sohbet turunu ajan altyapısının tamamına bağımlı
 * kılardı.
 *
 * Bedeli açık ve kabul edildi: sekme kapanınca konuşma gidiyor. Karşılığı da
 * açık — konuşmanın SAKLANMASI GEREKEN çıktısı zaten formda ve üretilen
 * kreatifte duruyor. Bir tur, bir formu doldurmak için var; arşivlenecek bir
 * belge üretmiyor.
 *
 * Tavan (`CREATIVE_DIRECTOR_TURN_MAX`) bu yüzden dar: taşınan her mesaj her
 * turda yeniden ağdan geçiyor ve yeniden jeton yakıyor.
 */

/// Bir istekte taşınabilecek en fazla mesaj (kullanıcı + asistan toplamı).
/// Aşan kısmı arayüz BAŞTAN kırpıyor: en yeni tur her zaman içeride kalmalı.
export const CREATIVE_DIRECTOR_TURN_MAX = 24;

/// Tek bir mesajın uzunluk tavanı.
export const CREATIVE_DIRECTOR_MESSAGE_MAX = 2000;

/**
 * 🔴 TUR BAŞINA 0 KREDİ — ve bu bir unutkanlık değil.
 *
 * Ajan sohbetiyle AYNI karar, aynı gerekçe (`agent-limit.service.ts`):
 * kredi ile sınırlansaydı bir soru sormak kreatif üretmekle aynı kovadan
 * yerdi ve kullanıcı tam da teşvik etmek istediğimiz şeyden kaçınırdı —
 * üretmeden ÖNCE düşünmekten.
 *
 * Adil kullanım GÜNLÜK MESAJ SAYACIYLA korunuyor ve sayaç ajanınkiyle
 * ORTAK: ikisi de aynı kaynağı (LLM turu) tüketiyor ve kullanıcıya iki ayrı
 * kotayı anlatmanın hiçbir karşılığı yok.
 */
export const CREATIVE_DIRECTOR_CREDITS = 0;

/* -------------------------------------------------------------------------- */
/* Formun modele gösterilen hâli                                               */
/* -------------------------------------------------------------------------- */

/**
 * Modelin GÖRDÜĞÜ ve YAZABİLDİĞİ alanlar — tam liste.
 *
 * ⚠️ `StudioState`in TAMAMI DEĞİL ve olmamalı. Dışarıda bırakılanlar ve
 * nedenleri:
 *
 *   · `assetKey` → kullanıcının yüklediği dosya. Modelin onu seçmesi ya da
 *     düşürmesi, kullanıcının açıkça yaptığı bir işi geri almak olurdu.
 *   · `logoAssetKey` → aynı gerekçe.
 *   · `sceneText` → sahne şablonunun metin yuvaları. Yazılabilir olsaydı
 *     model altı yuvayı doldurmaya çalışır ve o iş zaten `sceneAiCopy`
 *     anahtarının işi (reçete boş yuvayı modele devrediyor).
 */
export const directorFormSchema = z.object({
  /**
   * GÖRSEL Mİ VİDEO MU — 21 Ağu 2026'da eklendi.
   *
   * İlk sürümde yoktu ve direktör yalnız görsel tezgâhını sürüyordu. Beceri
   * kataloğu gelince o sınır anlamsızlaştı: kullanıcı "Ürün videosu"na
   * tıkladığında sohbetin onu video sekmesine geçirmesi gerekiyor, "ben
   * yalnız görsele bakıyorum" demesi değil.
   *
   * ⚠️ Alan bir süre ŞEMADA VARDI ama ARAYÜZDE ÖLÜYDÜ: panel yalnız
   * `state.kind === 'image'` iken basılıyordu, yani video becerisine
   * dokunmak reçetenin `kind: 'video'` varsayılanını uygular uygulamaz
   * paneli kendi üstüne kapatıyordu. Katalogdaki üç video becerisi bu yüzden
   * tıklanabilir ama kullanılamaz durumdaydı. Sınır kalktı (bkz.
   * `studio-workbench.tsx` → rayın iki yüzü).
   */
  kind: z.enum(['image', 'video']).optional(),
  /**
   * Sekme. Küme TÜRE GÖRE daralıyor ve bu daralma sunucuda ZORLANMIYOR:
   * `prompt` bir video isteğine yazılırsa arayüz onu görselin sekmesi olarak
   * uygular ve kullanıcı yanlış sekmede bulur — ama bu bir hata değil, bir
   * yanlış öneri. Şemayı ikiye bölmek (`imageMode` / `videoMode`) modelin
   * doldurması gereken alan sayısını artırırdı ve `strict` kapalı olduğu için
   * zaten kırpma katmanına dayanıyoruz.
   *
   *   görsel → prompt · product
   *   video  → product · ugc · template
   */
  mode: z.enum(['prompt', 'product', 'ugc', 'template']).optional(),
  brief: z.string().max(2000).optional(),
  /// Katalog ürünü kimliği; `null` = seçimi kaldır.
  productId: z.string().max(64).nullable().optional(),
  /// `sceneTemplates` kimliği; `null` = şablonsuz üret.
  sceneTemplateId: z.string().max(64).nullable().optional(),
  scenePalette: z.string().max(64).optional(),
  sceneNote: z.string().max(400).optional(),
  formatId: creativeFormatIdSchema.optional(),
  variants: z.number().int().min(1).max(4).optional(),
  /// Manken kimliği; `null` = mankensiz üret.
  presenterModelId: z.string().max(64).nullable().optional(),
  presenterAction: z.enum(PRESENTER_ACTIONS).optional(),
  presenterNote: z.string().max(200).optional(),

  /* --- video ekseni --------------------------------------------------------
     Yalnız `kind === 'video'` iken anlamlı. Görsel isteğinde gelirlerse
     arayüz onları yine state'e yazıyor (kullanıcı videoya geçtiğinde seçimini
     yerinde bulsun) ama üretim gövdesine girmiyorlar — `generateRequest`
     zaten `kind`e bakıyor. */

  /// Sağlayıcının kabul ettiği üç orandan biri.
  aspectRatio: z.enum(['16:9', '9:16', '1:1']).optional(),
  /// Saniye. Kredi bununla ölçekleniyor, o yüzden model onu KEYFİ seçemez —
  /// brief ona "uzun video pahalı" diyor.
  durationSeconds: z.number().int().min(3).max(20).optional(),
  withAudio: z.boolean().optional(),
  /// `videoTemplates` kimliği; `null` = şablonsuz.
  videoTemplateId: z.string().max(64).nullable().optional(),
  /// UGC'de konuşma metni. Kullanıcının dilinde.
  script: z.string().max(1200).optional(),
});
export type DirectorForm = z.infer<typeof directorFormSchema>;

/* -------------------------------------------------------------------------- */
/* Soru                                                                        */
/* -------------------------------------------------------------------------- */

/**
 * DİREKTÖRÜN SORDUĞU SORU — şıklı.
 *
 * ═══════════════════════════════════════════════════════════════════════════
 * 🔴 ŞIKLAR NEDEN ZORUNLU
 * ═══════════════════════════════════════════════════════════════════════════
 * Serbest metinle sorulan bir soru, kullanıcıya cümle kurdurur. Cümle kurmak
 * yazmaktır ve bu özelliğin bütün vaadi YAZMAMAK üzerine kurulu: kullanıcı
 * beceriyi seçiyor, ürününü yüklüyor, sonra yalnız DOKUNUYOR.
 *
 * Şıklar aynı zamanda modelin sorusunu da disipline ediyor: cevabı üç-dört
 * seçeneğe sığmayan bir soru, muhtemelen sorulmaması gereken bir sorudur.
 *
 * `options` boş gelirse arayüz soruyu düz bir mesaj gibi basıyor ve kullanıcı
 * yazarak cevaplıyor — model gerçekten açık uçlu bir şey sormak zorunda
 * kalabilir (ürünün adı, kampanyanın rakamı).
 */
export const DIRECTOR_QUESTION_OPTION_MAX = 5;

export interface DirectorQuestion {
  text: string;
  /**
   * Dokunulabilir cevaplar. Şıkkın METNİ cevabın kendisi — tıklama, o metni
   * kullanıcı mesajı olarak gönderiyor.
   *
   * Ayrı bir `value` alanı da olabilirdi ve olmadı: değer taşıyan bir şık,
   * konuşma geçmişinde etiketiyle değil koduyla görünürdü ve model bir
   * sonraki turda kullanıcının ne dediğini okuyamazdı.
   */
  options: string[];
}

export const directorMessageSchema = z.object({
  role: z.enum(['user', 'assistant']),
  text: z.string().trim().min(1).max(CREATIVE_DIRECTOR_MESSAGE_MAX),
});
export type DirectorMessage = z.infer<typeof directorMessageSchema>;

export const directorTurnSchema = z.object({
  /**
   * SEÇİLEN BECERİ — `CREATIVE_SKILLS` kimliği.
   *
   * Sohbetin çerçevesi. Model soruları bu becerinin `decides` listesinden
   * türetiyor ve varsayılanları ondan alıyor. Verilmezse sohbet serbest
   * kipte çalışıyor (eski davranış) — beceri seçmeden doğrudan yazan
   * kullanıcı için o yol AÇIK KALMALI.
   */
  skillId: z.string().max(64).optional(),
  /**
   * Konuşmanın TAMAMI, en eskiden en yeniye. Son eleman KULLANICININ yeni
   * mesajı olmak zorunda — sunucu bunu doğruluyor.
   *
   * Ayrı bir `message` alanı + geçmiş dizisi de olabilirdi ve olmadı: iki
   * alan, "son mesaj listede mi değil mi" sorusunu her çağıranın yeniden
   * cevaplaması demekti ve iki çağırandan biri bir gün yanlış cevaplardı.
   */
  messages: z.array(directorMessageSchema).min(1).max(CREATIVE_DIRECTOR_TURN_MAX),
  /// Formun ŞU ANKİ hâli — modelin neyi değiştireceğine karar verdiği taban.
  form: directorFormSchema,
  /**
   * YÜKLENEN FOTOĞRAFIN DEPO ANAHTARI — SALT OKUNUR BAĞLAM (21 Ağu 2026).
   *
   * ═══════════════════════════════════════════════════════════════════════
   * 🔴 NEDEN `directorFormSchema`DA DEĞİL, TURUN KENDİSİNDE
   * ═══════════════════════════════════════════════════════════════════════
   * Form modelin YAZDIĞI şey; bu alan modelin GÖREMEDİĞİ ama sunucunun
   * kullandığı şey. Forma konsaydı model onu yazabilir hâle gelirdi — yani
   * kullanıcının az önce yüklediği fotoğrafı düşürebilir ya da uydurduğu bir
   * anahtarı forma basabilirdi (`assetKey`in dışarıda bırakılma gerekçesi).
   *
   * Sunucu bununla TEK bir şey yapıyor: o fotoğrafın ürün görü analizini
   * (`ProductVisionAnalysis.sourceAssetKey`) okuyup prompt'a künye olarak
   * koyuyor. Anahtarın kendisi prompt'a GİRMİYOR — modele bir depo yolu
   * göstermenin hiçbir karşılığı yok.
   *
   * Bu alan olmadan sohbetten yüklenen bir fotoğraf direktör için GÖRÜNMEZDİ:
   * `readVision` yalnız `form.productId`ye bakıyordu, yani katalog ürünü
   * seçmeyen kullanıcı analizini ödeyip sonucunu sohbette hiç kullanamıyordu.
   */
  assetKey: z.string().max(400).optional(),
});
export type DirectorTurnInput = z.infer<typeof directorTurnSchema>;

export interface DirectorTurnResponse {
  /// Ekrana basılacak cümle(ler). Markdown DEĞİL, düz metin.
  reply: string;
  /**
   * Formun değişen alanları. `null` = bu turda forma dokunulmadı (model soru
   * sordu ya da yalnız yorum yaptı).
   *
   * Yalnız DEĞİŞEN alanlar dönüyor: tam form dönseydi kullanıcının o sırada
   * elle yazdığı bir alan sessizce eski değerine geri sarılırdı.
   */
  patch: DirectorForm | null;
  /**
   * Bu turda sorulan soru — `null` ise model soru sormuyor.
   *
   * Cevap ve soru AYNI turda dönebiliyor: model formu yamalayıp "peki şunu da
   * netleştirelim" diyebilir. İkisini ayrı turlara bölmek, kullanıcıya
   * ilerlemeden bir soru sormak olurdu.
   */
  question: DirectorQuestion | null;
  /**
   * Model "bence artık üretebiliriz" diyor mu.
   *
   * Arayüz bunu bir DÜĞMEYE çeviriyor, otomatik üretime DEĞİL — gerekçe
   * dosyanın başlığında.
   */
  suggestGenerate: boolean;
  /// Üreten model kimliği; künye satırında görünüyor.
  model: string;
}
